import React from 'react'
import { Button, Grid, Paper, Typography, Box } from '@mui/material'
import logo from '../images/AGWE.png'

function AgwePage (props) {
  const { setViewPage } = props
  return (
    <Grid container spacing={5}>
      <Grid item xs={6}>
        <Grid item xs={12}>
          <Box sx={1} />
          <Typography
            variant='h7'
            component='div'
            style={{
              fontSize: 'xx-large',
              textAlign: 'center',
              width: '100%',
              fontFamily: 'sans-serif',
              marginTop: '10vh'
            }}
          >
            <strong>WELCOME TO A. G. W. E.</strong>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Paper
            style={{
              padding: '10%',
              marginLeft: '50px',
              marginRight: '50px',
              marginTop: '2vh',
              backgroundColor: '#e2cfc5',
              borderRadius: '10%'
            }}
          >
            <Typography
              variant='h7'
              component='div'
              style={{
                fontSize: 'xx-large',
                textAlign: 'center',
                width: '100%',
                // fontFamily: 'emoji',
                marginTop: '2vh'
              }}
            >
              <strong style={{ fontFamily: 'sans-serif' }}>
                {'Assessing Algal Growth in Water Eutrophication (A. G. W. E.)'}
              </strong>

              {
                ' is a risk-assessment tool for monitoring and preventing HABs in targeted areas. It visually presents the chlorophyll and sea surface temperature from NASA’s space data crucial for detection of HABs.'
              }
            </Typography>
            ;
            <Typography
              variant='h7'
              component='div'
              style={{
                fontSize: 'xx-large',
                textAlign: 'center',
                width: '100%',
                fontFamily: 'sans-serif',
                marginTop: '2vh'
              }}
            >
              <strong>{'Harmful algal blooms (HABs)'}</strong>
              {
                ' is a rampant spread of seaweeds and cause detrimental effects on humans, birds, fish, shellfish, and marine mammals.'
              }
            </Typography>
          </Paper>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <div style={{ paddingTop: '5vh' }}>
          {<img src={logo} alt='' width='600vw' height='600vh'></img>}
        </div>
        <div style={{ paddingLeft: '4vw' }}>
          <Button
            size='large'
            variant='contained'
            style={{
              backgroundColor: '#dbd3d8',
              color: '#377534',
              paddingTop: '3vh',
              paddingLeft: '12vh',
              paddingRight: '12vh',
              paddingBottom: '3vh',
              fontSize: '4vh',
              fontFamily: 'sans-serif'
            }}
            onClick={_ => setViewPage('MapPage')}
          >
            <strong style={{ fontFamily: 'sans-serif' }}>View Map</strong>
          </Button>
        </div>
      </Grid>
    </Grid>
  )
}

export default AgwePage
